<template>
	<div>
		<div class="position-relative">
			<div class="row">
				<div class="col-1 col-md-4"></div>
				<div class="col-10 col-md-4">
					<div class="text-center">
						<br />
						<br />
						<img
							src="/img/logo_with_caption.png"
							width="100%"
						/>
					</div>
					<div class="col-1 col-md-4"></div>
				</div>
			</div>
			<div
				class="container"
				style="margin-top: 20px"
			>
				<div class="row">
					<div
						class="col-md-3 col-6 card-bphtb"
						@click="goForm()"
					>
						<component
							:is="'a'"
							class="text-white card-pajak"
						>
							<!-- <card class="border-0 d-flex card-bphtb" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center"> -->
							<!-- <object type="image"> -->
							<img
								class="img-button"
								src="/img/icons/Inside Button-03.png"
							/>
							<!-- </object> -->
							<!-- </card> -->
						</component>
					</div>
					<div
						class="col-md-3 col-6 card-bphtb"
						@click="goTracking()"
					>
						<component :is="'a'">
							<!-- <card class="border-0 d-flex card-sipp" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center"> -->
							<object
								type="image"
								class="text-white card-pajak"
							>
								<img
									class="img-button"
									src="/img/icons/Inside Button-04.png"
								/>
							</object>
							<!-- <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">
                  TRACKING BPHTB
                </h6>
              </card> -->
						</component>
					</div>

					<div
						class="col-md-3 col-6 card-bphtb"
						@click="goHistories()"
					>
						<component :is="'a'">
							<!-- <card class="border-0 d-flex card-hiburan" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center"> -->
							<object
								type="image"
								class="text-white card-pajak"
							>
								<img
									class="img-button"
									src="/img/icons/Inside Button-05.png"
								/>
							</object>
							<!-- <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">
                  HISTORI TRANSAKSI
                </h6>
              </card> -->
						</component>
					</div>

					<div
						class="col-md-3 col-6 card-bphtb"
						@click="goDaftar()"
					>
						<component
							:is="'a'"
							style="height: 100%"
						>
							<!-- <card class="border-0 d-flex card-database" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center"> -->
							<object
								type="image"
								class="text-white card-pajak"
							>
								<img
									class="img-button"
									src="/img/icons/Inside Button-06.png"
								/>
							</object>
							<!-- <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">
                  LIST PENDAFTARAN
                </h6>
              </card> -->
						</component>
					</div>
				</div>
				<br />
				<div class="row">
					<div class="col-3"></div>
					<div
						class="col-12 col-md-6 card-imagee-bphtb border-0 d-flex"
						@click="panduan()"
					>
						<component :is="'a'">
							<!-- <card class="border-0 d-flex card-bphtb" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center"> -->
							<object
								type="image"
								class="text-white text-center align-items-center d-flex justify-content-center"
							>
								<img
									class="img-button-panduan"
									src="/img/icons/Inside Button-07.png"
								/>
							</object>
							<!-- </card> -->
						</component>
					</div>
					<div class="col-3"></div>
				</div>
			</div>
		</div>
		<br />
		<registration
			ref="modal-registration"
			title="Registrasi User"
		></registration>
		<login-user ref="modal-login"></login-user>
		<modal-tracking ref="modal-tracking"></modal-tracking>
		<modal-histories ref="modal-histories"></modal-histories>
		<panduan ref="modal-panduan"></panduan>
	</div>
</template>
<script>
	import Registration from "./GlobalPage/Regstration.vue"
	import LoginUser from "@/views/GlobalPage/LoginUser"
	import ModalTracking from "@/views/GlobalPage/Tracking"
	import ModalHistories from "@/views/GlobalPage/Histories"
	import Panduan from "@/views/GlobalPage/Panduan"
	export default {
		name: "home",
		components: {
			Registration,
			LoginUser,
			ModalTracking,
			ModalHistories,
			Panduan,
		},
		computed: {
			isLogin() {
				return this.$store.state.auth.status.loggedIn
			},
			registration_label() {
				return this.$store.state.auth.status.loggedIn
					? this.$store.state.auth.user.name
					: "REGISTRASI"
			},
		},
		mounted() {
			this.$forceUpdate()
		},
		methods: {
			goRegistration() {
				this.$refs["modal-registration"].showModal()
				if (this.isLogin) {
					this.$refs["modal-registration"].updateMode(
						this.$store.state.auth.user
					)
				}
			},
			goDaftar() {
				if (this.isLogin) {
					this.$router.push("/bphtb/daftar")
				} else {
					this.login()
				}
			},
			goForm() {
				if (this.isLogin) {
					this.$router.push("/bphtb/from-daftar")
				} else {
					this.login()
				}
			},
			goTracking() {
				if (this.isLogin) {
					this.$refs["modal-tracking"].showModal()
				} else {
					this.login()
				}
			},
			goHistories() {
				this.$refs["modal-histories"].showModal()
			},
			login() {
				this.$refs["modal-login"].showModal()
			},
			async logout() {
				await this.$store.dispatch("auth/logout")

				this.$router.push("/home")
			},
			panduan() {
				this.$refs["modal-panduan"].showModal()
			},
		},
	}
</script>
